import { render, staticRenderFns } from "./ValueChainOutputForm.vue?vue&type=template&id=1cbbf432"
import script from "./ValueChainOutputForm.vue?vue&type=script&lang=js"
export * from "./ValueChainOutputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports